"use client";
import Link from "@/components/Link";
import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Row } from "@dxp-feed/ui/Row";
import { Text } from "@dxp-feed/ui/Text";
import { Columns } from "@dxp-feed/ui/Columns";
import { SiteContainer } from "@/components/Container";
import { addDataLayer } from "@/helpers/dataLayer";
import { useAppDispatch, useAppSelector, useEffect } from "@/utils/hooks/reactUseCustomHooks";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import { resetShoppingList } from "@/utils/redux/shoppingList";
import { addOrUpdateListItemsToCart, getShoppingCartItems } from "@/utils/redux/shoppingList/actions";
import { fetchFavouriteProducts } from "@/utils/redux/favouriteProduct/actions";
import { ShoppingListItem } from "@/utils/types/manageList";

export default function Social({ footerData }: any) {
  const {
    loggedIn: userLoggedIn,
    uid: uid,
    scene,
  } = useAppSelector((state) => state.gigyaslice);
  const gigyaToken = useGigyaAccountInfo();
  const selectedStore: any = useAppSelector(
    (state) => state?.selectedStore.data
  );
  const shoppingList: Record<string, any> = useAppSelector(
    (state) => state?.shoppingListSlice
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      const response = await gigyaToken();
      if (response.idToken != "" && response.uid != "" && userLoggedIn) {

        await saveDataAndLogin({
          id_token: response.idToken,
          uid: response.uid,
        });
      }
    })()
  }, [userLoggedIn, selectedStore.storeNumber]);

  const saveDataAndLogin = async (userInfo: {
    uid: string;
    id_token: string;
  }) => {


    if (
      (shoppingList?.shoppingListProducts?.products?.length || shoppingList?.shoppingListProducts?.custom?.length) &&
      shoppingList?.isAuthenticated === false
    ) {
      let shoppingProducts = []
      let shoppingCustoms = []

      if (shoppingList?.shoppingListProducts?.products?.length > 0) {
        shoppingProducts = shoppingList?.shoppingListProducts?.products
          ?.map((item: ShoppingListItem) => {
            let newItemId = item?.item_id;
            const parts = newItemId?.split('_');
            let lastPart = "";
            if(parts){
              lastPart = parts[parts.length - 1];
            }
            if (!isNaN(Number(lastPart))) {
              parts?.pop();
              newItemId = parts?.join('_');
            }

            return {
              item_id: newItemId,
              product_type: item?.product_type,
              quantity: item?.quantity,
              meta: item?.meta
            };
          });
      }

      if (shoppingList?.shoppingListProducts?.custom?.length > 0) {
        shoppingCustoms = shoppingList?.shoppingListProducts?.custom
          ?.map((item: {
            meta: any;
            quantity: any; item_id: string; id: string; product_type: string
          }) => {
            return {
              item_id: "0",
              product_type: item?.product_type,
              quantity: item?.quantity,
              meta: item?.meta

            };
          });
      }

      const mergedShoppingList = [
        ...(shoppingProducts),
        ...(shoppingCustoms),
      ];

      if (mergedShoppingList?.length) {
        dispatch(resetShoppingList());
        const payload = {
          userToken: userInfo.id_token,
          items: mergedShoppingList,
          storeId: selectedStore?.storeNumber
        };
        const saveResult = await dispatch(addOrUpdateListItemsToCart(payload));

        if (saveResult.type === "add_or_update_list_to_cart/fulfilled") {
          dispatch(
            getShoppingCartItems({
              userToken: userInfo?.id_token,
              storeId: selectedStore?.storeNumber,
            })
          );
        }
      }
    } else {
      dispatch(
        getShoppingCartItems({
          userToken: userInfo?.id_token,
          storeId: selectedStore?.storeNumber,
        })
      );
    }
    dispatch(
      fetchFavouriteProducts({
        userToken: userInfo?.id_token,
        storeId: selectedStore?.storeNumber,
      })
    );

  };
  return (
    <Box as="div" className="bg-brandSecondary py-4 lg:!py-6" role="navigation">
      <SiteContainer>
        <Row className="pb-0 justify-between">
          <Columns className="col-6 hidden lg:!block">
            <Box as="div" className="flex gap-6">
              <Box as="div" className="flex items-center gap-[24px]">
                <main>
                  <Text
                    as="span"
                    className="text-brandWhite text-body font-semibold leading-normal"
                  >
                    {footerData?.customerServiceTitle}
                  </Text>
                </main>
                {footerData?.horizontalList &&
                  <nav className="flex gap-6">
                    {footerData?.horizontalList.map(
                      (horizontalItem: any, index: number) => (
                        <Link
                          href={horizontalItem?.link ?? "#"}
                          className="text-brandWhite text-body font-light leading-normal underline"
                          aria-label={horizontalItem.label}
                          key={horizontalItem?.label + index}
                          target={horizontalItem?.target}
                          scroll={true}
                          onClick={() =>
                            addDataLayer({
                              event: "nav_footer",
                              click_text: horizontalItem?.label,
                              click_url: horizontalItem?.link ?? "",
                              page_title: document?.title,
                            })
                          }
                        >
                          {horizontalItem?.label}
                        </Link>
                      )
                    )}
                  </nav>
                }
              </Box>
            </Box>
          </Columns>
          <Columns className="col-6 justify-end w-full lg:!w-auto mr-0">
            <Box as="div" className="flex gap-6 w-full">
              <Box
                as="div"
                className="flex items-center gap-[10px] w-full justify-end"
              >
                <main>
                  <Text
                    as="span"
                    className="text-brandWhite text-body font-normal leading-normal"
                  >
                    {footerData?.connectwithusTitle}
                  </Text>
                </main>
                <nav className="flex items-center gap-[10px]">
                  {footerData?.socialLinks.map(
                    (socialItem: any, index: number) => (
                      <Link
                        href={socialItem?.link ?? "#"}
                        className="text-sm"
                        key={socialItem?.label + index}
                        target={socialItem?.target}
                        rel={socialItem?.target === "_blank" ? "noopener" : undefined}
                        aria-label={socialItem?.label}
                        onClick={() =>
                          addDataLayer({
                            event: "nav_footer",
                            click_text: socialItem?.label,
                            click_url: socialItem?.link ?? "",
                            page_title: document?.title,
                          })
                        }
                      >
                        <span
                          className={`${socialItem?.label} text-brandWhite text-base`}
                        ></span>
                      </Link>
                    )
                  )}
                </nav>
              </Box>
            </Box>
          </Columns>
        </Row>
      </SiteContainer>
    </Box>
  );
}
